import React, { useRef, useState } from 'react';
import classNames from 'classnames';
import useOutsideClick from '../../utils/useOutsideClick';
import CavronIcon from '../../Assets/CavronIcon';
import Input from '../Input';

import './dropdown.scss';
import { CloseIcon } from '../../Assets';

const errorText = ({ errorMessage, isValid }) => {
  if (isValid) {
    return null;
  }

  return <div className="error-msg">{errorMessage}</div>;
};

const DropdownAtom = ({
  options,
  onChange,
  value = '',
  title,
  name,
  closeIcon,
  handleClose,
  ...rest
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [error, setErrors] = useState({ errorMessage: '', isValid: true });
  const ref = useRef();
  const toggle = () => setDropdownOpen(!dropdownOpen);

  const handleClick = (e) => {
    onChange({ target: { name, value: e.target.dataset.value } });
    toggle();
  };

  const classes = classNames('dropdown', {
    expanded: dropdownOpen,
    error: !error.isValid,
  });
  const classesSelected = classNames('wrapper-item', {
    'wrapper-selected': dropdownOpen,
    error: !error.isValid,
  });

  const getValue = () => {
    const { title = 'Select' } =
      options.find((option) => option.value.toString() === value.toString()) ||
      {};
    return title;
  };

  useOutsideClick(ref, () => {
    if (dropdownOpen) {
      toggle(false);
    }
  });

  const setError = (isValid, message) => {
    setErrors({ errorMessage: message, isValid });
  };

  return (
    <div className="main-wrapper custom-dropdown" ref={ref}>
      <div className={classesSelected} onClick={toggle}>
        {title && <label>{title}</label>}
        <div className="icon-wrapper">
          {closeIcon && (
            <CloseIcon
              width={14}
              style={{ marginRight: 10 }}
              onClick={handleClose}
            />
          )}
          <CavronIcon />
        </div>
        <div className="selected">{getValue()}</div>
      </div>
      <div className={classes}>
        {options.map((option, index) => (
          <div
            data-value={option.value}
            key={index}
            onClick={handleClick}
            className="option"
          >
            {option.title}
          </div>
        ))}
      </div>
      {errorText(error)}
      <Input
        name={name}
        value={value}
        hide
        validators={['required']}
        errorMessages={['this field is required']}
        formValid={true}
        onChange={onChange}
        setError={setError}
      />
    </div>
  );
};

export default DropdownAtom;
